module.exports = "/src/views/player/help/images/pd.jpg";